import React from "react";
import { IoSchoolOutline, IoTrendingUpOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaRegMoneyBillAlt } from "react-icons/fa";
const Statistics = () => {
  return (
    <div className=" rounded-md bg-white h-full  p-4 text-[#5E5873] shadow-md   ">
      <div className="   text-[#5e5873] font-medium text-xl ml-5">Statistics</div>
      <div className="grid grid-cols-2 md:grid-cols-2  gap-y-4 md:gap-y-0 h-full items-center lg:mt-[-10px] ">
        <div className="flex items-center  justify-center    ">
          <div className="bg-[#EEEDFD] p-3 rounded-full  mr-2">
            <IoSchoolOutline className=" text-[#7367F0] text-xl md:text-xl  "></IoSchoolOutline>
          </div>
          <div>
            <h1 className=" text-lg  font-semibold ">43.5</h1>
            <p className=" text-xs">Credit</p>
          </div>
        </div>
        <div className="flex items-center  justify-center  ">
          <div className="bg-[#E0F9FC] p-3 rounded-full  mr-2">
            <IoTrendingUpOutline className=" text-[#00CFE8] text-xl md:text-xl"></IoTrendingUpOutline>
          </div>
          <div className=" text-center">
            <h1 className="text-lg  font-semibold">15th</h1>
            <p className=" text-xs">Rank</p>
          </div>
        </div>
        <div className="flex items-center  justify-center    ">
          <div className="bg-[#FCEAEA] p-3 rounded-full mr-2">
            <GiReceiveMoney className=" text-[#EA5455] text-xl md:text-xl"></GiReceiveMoney>
          </div>
          <div>
            <h1 className="text-lg font-semibold ">45k</h1>
            <p className=" text-xs">Due</p>
          </div>
        </div>
        <div className="flex items-center  justify-center">
          <div className="bg-[#E5F8ED] p-3 rounded-full mr-2">
            <FaRegMoneyBillAlt className=" text-[#28C76F] text-xl md:text-xl"></FaRegMoneyBillAlt>
          </div>
          <div>
            <h1 className="text-lg font-semibold ">258k</h1>
            <p className=" text-xs">Paid</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
